module.exports = __webpack_public_path__ + "img/rr-logo.4f172b78.png";